export const ASIDE_WIDTH = 420;
export const DRAWER_WIDTH = 320;
export const DRAWER_COLLAPSED_WIDTH = 88;
export const NAVBAR_HEIGHT = 64;
